import { USER_ACCOUNTS_QUERY_KEY } from '@/lib/query/constants/account-keys-constants';

export const accountKeys = {
  all: [USER_ACCOUNTS_QUERY_KEY] as const,
  list: () => accountKeys.all,
};
